import { Injectable } from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {Activite} from "app/suaps/common/services/activite/activite.model";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ActiviteService extends DaoGeneric<Activite> {

  readonly url = `${environment.baseUrl}/suaps/activite/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(): string {
    return this.url;
  }
}
